import styled from 'styled-components';
import { inlineLink, smallParagraph } from '../../../../theme/typography';

export const Container = styled.div`
  margin-top: 40px;
`;

export const Line = styled.p`
  ${smallParagraph};
  text-align: left;

  &:not(:first-child) {
    margin-top: 24px;
  }
`;

export const Link = styled.a`
  ${inlineLink};
  ${smallParagraph};
`;
